import { getApprenticeshipTypeName } from "@/helpers/job"

/**
 * Generates a preview message for (e.g. ChatList component) for every action-message.
 */
export function schoolNetworkRequestPrefill({ business }) {
    let contact_name = ""
    if (business.contact_person) {
        contact_name =
            business.contact_person.firstname +
            " " +
            business.contact_person.lastname
    }
    let intro = ""
    if (contact_name) {
        intro =
            "mein Name ist " +
            contact_name +
            " von der Firma " +
            business.name +
            ".\n"
    }

    return `Sehr geehrte Damen und Herren,

${intro}Ich würde mich gerne mit Ihnen vernetzen, um ihren Schülern Einblicke in unseren Arbeitsalltag zu bieten.
Ihre Schüler können mir im Oabat-Chat jederzeit Fragen zur Ausbildung stellen.
Wir bieten auch gerne Schülerpraktika an (z.B. im Rahmen von Praktikumswochen an Ihrer Schule).
Bitte kontaktieren Sie mich auch, wenn Sie Referenten an Ihrer Schule brauchen, oder Betriebserkundungen mit Ihren Schülern unternehmen möchten.

Mit freundlichen Grüßen
${contact_name}`
}

export function businessNetworkRequestPrefill({ user, businessSite }) {
    const name = businessSite.name
    const city = businessSite.primary_address.city
    const schoolPrefix = user.school.type === "Gymnasium" ? "vom" : "von der"
    return `Sehr geehrte Damen und Herren,

mein Name ist ${user.firstname} ${user.lastname} und ich bin ${schoolPrefix} "${user.school.name}".
Gerne würden wir unsere Schule mit Ihnen und ${name} am Standort ${city} vernetzen, um unseren SchülerInnen eine zeitgemäße Berufsorientierung zu ermöglichen.
Bitte kontaktieren Sie mich jederzeit gerne, wenn Sie Fragen zur Berufsorientierung an unserer Schule haben oder unseren SchülerInnen etwas anbieten möchten.
Ich freue mich von Ihnen zu hören.

Mit freundlichen Grüßen
${user.firstname} ${user.lastname}`
}

export function businessNetworkRequestActivityPrefill({ user, activity }) {
    const schoolPrefix = user.school.type === "Gymnasium" ? "vom" : "von der"
    return `Sehr geehrte Damen und Herren,

mein Name ist ${user.firstname} ${user.lastname} und ich bin ${schoolPrefix} "${user.school.name}".
Wir haben großes Interesse an Ihrem Angebot „${activity}” und möchten es gerne für die Berufsorientierung an unserer Schule nutzen.
Bitte kontaktieren Sie mich, damit wir uns dazu austauschen können.
Ich freue mich von Ihnen zu hören.

Mit freundlichen Grüßen
${user.firstname} ${user.lastname}`
}

export function businessActivityMessagePrefill({ businessSite, activity }) {
    const cp = businessSite.public_contact_person
    const city = businessSite.primary_address.city
    let name = ""
    if (cp) name = ` ${cp.gender} ${cp.lastname}`
    return `Hallo${name},

Ich habe Interesse an Ihrem Angebot „${activity}‟ am Standort ${city}. Können Sie mir genauere Information dazu geben?`
}

export function jobInterestMessagePrefill({
    job,
    contactPerson,
    selectedDates,
    apprenticeshipYear,
}) {
    if (apprenticeshipYear) {
        const apprTypeName = getApprenticeshipTypeName(job.apprenticeship)
        if (apprenticeshipYear === "unknown") {
            return `Hallo ${contactPerson ?? ""},

ich interessiere mich sehr für Ihren Beruf "${
                job.name
            }" und möchte mich für die ${apprTypeName} bewerben.`
        }
        return `Hallo ${contactPerson ?? ""},

ich interessiere mich sehr für Ihren Beruf "${
            job.name
        }" und möchte mich zur ${apprTypeName} ab dem ${apprenticeshipYear} bewerben.\nBitte lassen Sie mich wissen, welche Unterlagen Sie für eine vollständige Bewerbung von mir benötigen.`
    }
    if (selectedDates.length === 2) {
        if (job.type_id === 2) {
            return `Hallo ${contactPerson ?? ""},

ich interessiere mich sehr für Ihr Praktikum "${
                job.name
            }". Wäre es denn möglich, dass ich das Praktikum vom ${
                selectedDates[0]
            } bis zum ${selectedDates[1]} ausprobiere?`
        }
        return `Hallo ${contactPerson ?? ""},

ich interessiere mich sehr für Ihren Beruf "${
            job.name
        }". Wäre es denn möglich, dass ich das bei Ihnen im Betrieb vom ${
            selectedDates[0]
        } bis zum ${selectedDates[1]} in einem Praktikum ausprobiere?`
    }
    if (selectedDates.length === 1) {
        if (job.type_id === 2) {
            return `Hallo ${contactPerson ?? ""},

ich interessiere mich sehr für Ihr Praktikum "${
                job.name
            }". Wäre es denn möglich, dass ich das Praktikum am ${
                selectedDates[0]
            } ausprobiere?`
        }
        return `Hallo ${contactPerson ?? ""},

ich interessiere mich sehr für Ihren Beruf "${
            job.name
        }". Wäre es denn möglich, dass ich das bei Ihnen im Betrieb am ${
            selectedDates[0]
        } in einem Praktikum ausprobiere?`
    }
    if (job?.type_id === 1)
        return `Hallo ${contactPerson ?? ""},

ich interessiere mich sehr für Ihren Beruf "${
            job.name
        }" und würde diesen gerne ausprobieren.
Wäre das im Rahmen eines Praktikums möglich?`

    return `Hallo ${contactPerson ?? ""},

ich interessiere mich sehr für Ihren Beruf "${
        job.traineeship.name
    }". Wäre es denn möglich, dass ich das bei Ihnen im Betrieb demnächst in einem Praktikum ausprobieren könnte?`
}

/** trainee can be unset */
export function initialChatFormMessage(trainee) {
    if (trainee) {
        if (trainee.is_profile_data_complete) {
            return [
                {
                    body: `Hey ${trainee.firstname}, schön dass du dich für unsere Stelle interessierst. Wir würden dich gerne näher kennenlernen. Stimmen diese Angaben noch?`,
                    type: "regular",
                    sender_id: null,
                    created_at: new Date(),
                },
                {
                    body: trainee,
                    type: "profile",
                    sender_id: null,
                },
            ]
        } else {
            return [
                {
                    body: `Hey ${trainee.firstname}, schön dass du dich für unsere Stelle interessierst. Wir würden dich gerne näher kennenlernen. Verrate mir dazu einfach ein paar Infos über dich.`,
                    type: "regular",
                    sender_id: null,
                },
            ]
        }
    }
    return [
        {
            body: "Hey, schön dass du dich für unsere Stelle interessierst. Wir würden dich gerne näher kennenlernen. Verrate mir dazu einfach ein paar Infos über dich.",
            type: "regular",
            sender_id: null,
            created_at: new Date(),
        },
    ]
}

export function welcomeBusinessAsChannel(business, user) {
    const channel = user.region.channel
    const name = `${user.firstname} ${user.lastname}`
    let message = `Sehr geehrte ${business?.name ?? "Damen und Herren"},`

    message += `

herzlich Willkommen auf unserer Plattform und Kampagne ${channel.name}. Gerne können Sie hier über Oabat den Kontakt zu mir aufnehmen. Lassen Sie mich wissen, wie ich Ihnen helfen kann.
Ich freue mich sehr auf unsere Zusammenarbeit.

Liebe Grüße ${name}`

    return message
}

export function bookTimeSlot(business, timeSlot, eventTitle) {
    let cpString = null
    const cp = business.public_contact_person
    if (cp) {
        cpString = `${cp.gender} ${cp.lastname}`
    }
    const startTime = timeSlot.timeSlot.split("-")[0].trim()
    const day = timeSlot.day.length > 1 ? timeSlot.day : "0" + timeSlot.day
    const month = new Date(2020, Number(timeSlot.month - 1)).toLocaleString(
        "de-DE",
        { month: "long" }
    )
    let message = `Hallo ${cpString ?? ""},\n`
    message += `für die ${eventTitle} würde ich gerne einen Gesprächstermin bei Ihnen vereinbaren.\n`
    message += `Haben Sie am ${day}. ${month}`
    message += ` um ${startTime} Zeit dafür?`
    return message
}
